import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneLight, vs } from 'react-syntax-highlighter/dist/esm/styles/prism';
import Carousel from '../../items/Carousel';

const IotmTable = ({ event, options }) => {
  const [showTable, setShowTable] = React.useState(false);
  const [showScen, setShowScen] = React.useState(false);
  const { t, i18n } = useTranslation();

  return (
    <div className='grid grid-cols-1 justify-items-center'>
      <div className='w-full'>
        <div>
          <p class='text-center font-bold whitespace-pre-wrap my-2 text-gray-600 truncate dark:text-slate-300'>
            {event.topic[i18n.language]}
          </p>
          <p class='text-left whitespace-pre-wrap my-2 text-gray-600 truncate dark:text-slate-300'>
            {event.text[i18n.language]}
          </p>
        </div>
        <Carousel event={event}></Carousel>
      </div>
    </div>
  );
};

export default IotmTable;
